// extracted by mini-css-extract-plugin
module.exports = {"error":"CheckoutInputError_error__DMaQ7"};